import React, { memo, useContext } from 'react'
import { useSelector } from 'react-redux'
import { selectRenderSettings } from 'selectors/mainView'
import { Box, Checkbox, FormControlLabel } from '@material-ui/core'
import { FormContext } from 'contexts/FormContext'
import { RenderSettings as RenderSettingsEnum } from 'config/constants/editorSettings'
import { TranslationContext } from 'contexts/TranslationContext'

export const RenderSettingsPanel = memo(() => {
  const { handleInput } = useContext(FormContext)
  const renderSettings = useSelector(selectRenderSettings)
  const { t } = useContext(TranslationContext)

  return (
    <Box width="100%">
      <form className="render-settings" key={RenderSettingsEnum.skipEmptySpace}>
        <FormControlLabel
          control={(
            <Checkbox
              onChange={handleInput}
              color="primary"
              name={RenderSettingsEnum.skipEmptySpace}
              checked={Boolean(renderSettings[RenderSettingsEnum.skipEmptySpace])}
            />
          )}
          label={t('RENDER_SETTINGS_START_RENDERING_FROM_THE_FIRST_CLIP')}
        />
        <FormControlLabel
          control={(
            <Checkbox
              onChange={handleInput}
              color="primary"
              name={RenderSettingsEnum.askPublishOutputName}
              checked={Boolean(renderSettings[RenderSettingsEnum.askPublishOutputName])}
            />
          )}
          label={t('RENDER_SETTINGS_ASK_PUBLISH_OUTPUT_NAME')}
        />
        <FormControlLabel
          control={(
            <Checkbox
              onChange={handleInput}
              color="primary"
              name={RenderSettingsEnum.closePublishSettingsOnCancel}
              checked={Boolean(renderSettings[RenderSettingsEnum.closePublishSettingsOnCancel])}
            />
          )}
          label={t('RENDER_SETTINGS_CLOSE_PUBLISH_SETTINGS_ON_CANCEL')}
        />
      </form>
    </Box>
  )
})
